import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { CurrenciesController } from './currencies.controller';
import { CurrenciesService } from './currencies.service';
import {Currencies } from './currencies.entity';
import {CurrenciesAdapter} from './dto/currencies.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    
    TypeOrmModule.forFeature([Currencies]),
    // forwardRef(() => ClusterModule),
  ],
  controllers: [CurrenciesController],
  providers: [CurrenciesService,CurrenciesAdapter,ApplicationExceptionHandler,LogsService],
  exports: [CurrenciesService],
})
export class CurrenciesModule {}
